var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37451 15H5.38607M1 3.69689C1.62501 2.12753 3.34751 1 5.37451 1C7.92905 1 10 2.79086 10 5C10 6.6565 8.83565 8.0778 7.17614 8.6852C6.3195 8.9988 5.89118 9.1556 5.74131 9.2767C5.56288 9.4209 5.529 9.4651 5.44505 9.6634C5.37451 9.8299 5.37451 10.0866 5.37451 10.6V12",
    stroke: "#D81F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.48edf3d8224e5d03241e5f2856230e4b.svg";
export { ForwardRef as ReactComponent };